<template>
  <div class="offer-item">
    <img
      class="offer-img"
      src="../../../public/custom/images/kapysta.svg"
      alt="Kapysta image"
    />
    <div class="offer-item-amount">{{ item.loan_amount / 100 }}</div>
    <div class="offer-item-return">
      {{ formattedReturnAmount }}
    </div>
    <div class="offer-issued-by">{{ item.loan_term_days + " д." }}</div>
    <div class="offer-rating">{{ item.borrower_min_rating }}</div>
    <div class="offer-btn-block">
      <base-button
        :text="$t('message.mainPage.offers.btn')"
        class="offer-btn"
        @click="getOffer(item)"
        :is-loading="isOfferBtnLoading"
        :spinner-color="'#41BF7B'"
        :class="{ 'offer-btn-loading': isOfferBtnLoading }"
        :disabled="isOfferBtnLoading"
      />
    </div>
    <div class="offer-amount-block-mobile">
      <div class="mobile-title">
        {{ $t("message.mainPage.offers.tableTitle.amount") }}
      </div>
      <div class="offer-item-amount">{{ item.loan_amount / 100 }}</div>
    </div>
    <div class="offer-return-block-mobile">
      <div class="mobile-title">
        {{ $t("message.mainPage.offers.tableTitle.returnMobile") }}
      </div>
      <div class="offer-item-return">
        {{ formattedReturnAmount }}
      </div>
    </div>
    <div class="offer-issued-block-mobile">
      <div class="mobile-title">
        {{ $t("message.mainPage.offers.tableTitle.issuedBy") }}
      </div>
      <div class="offer-issued-by">{{ item.loan_term_days + " д." }}</div>
    </div>
    <div class="offer-rating-block-mobile">
      <div class="mobile-title">
        {{ $t("message.mainPage.offers.tableTitle.rating") }}
      </div>
      <div class="offer-rating">{{ item.borrower_min_rating }}</div>
    </div>
    <div class="offer-btn-block-mobile">
      <base-button
        :text="$t('message.mainPage.offers.btn')"
        class="offer-btn"
        @click="getOffer(item)"
        :is-loading="isOfferBtnLoading"
        :spinner-color="'#41BF7B'"
        :class="{ 'offer-btn-loading': isOfferBtnLoading }"
        :disabled="isOfferBtnLoading"
      />
    </div>
  </div>
</template>

<script>
import BaseButton from '../../components/base/BaseButton.vue';
export default {
  name: "offerItem",
  inject: ["$httpService"],
  props: {
    item: Object,
    profile: Object
  },
  components: {
    BaseButton
  },
  data() {
    return {
      isOfferBtnLoading: false,
    };
  },
  methods: {
    getOffer(item) {
      if(!this.isOfferBtnLoading) {
        this.profile?.role === "lender"
        ? this.goToProfile()
        : this.goToContract(item);
      }
    },
    goToProfile() {
      this.$router.push({ name: "profile" });
    },
    goToContract(item) {
      if (this.isAuthorized) {
        this.profile?.default_card_id
          ? this.viewContact(item.public_id)
          : this.$router.push({ name: "cards" });
      } else {
        this.$router.push({ name: "SignIn" });
      }
    },
    async viewContact(public_id) {
      this.isOfferBtnLoading = true;
      this.$store.dispatch('loading', true);
      try {
        const response = await this.$httpService.loan.createLoan(public_id);

        this.$router.push({
          name: "contract",
          query: { agreement_id: response.data?.agreementId },
        });
        this.isOfferBtnLoading = false;
        this.$store.dispatch('loading', false);
      } catch (error) {
        this.isOfferBtnLoading = false;
        this.$store.dispatch('loading', false);
      }
    },
  },
  computed: {
    isAuthorized() {
      return !!this.profile?.role;
    },
    formattedReturnAmount() {
      const amount = (this.item.loan_amount + this.item.expected_income) / 100;
      return amount.toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.offer-item,
.title-item {
  padding-bottom: 13px;
  box-sizing: border-box;
  height: 62px;
  width: calc(50% - 30px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eceef0;
  font-weight: 400;
  font-size: 18px;
  line-height: 135%;
  color: #121212;
}

.title-item {
  border: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #878787;
}

.offer-img {
  height: 30px;
  width: 30px;
  margin-right: 8px;
}

.offer-item-amount {
  width: 13%;
  margin-right: 4px;
}

.offer-item-return {
  width: 15%;
  margin-right: 4px;
}

.offer-issued-by {
  width: 12%;
  margin-right: 4px;
}

.offer-rating {
  width: 13%;
  margin-right: 4px;
}

.offer-btn-block {
  width: 170px;
  height: 36px;
}

.offer-btn ::v-deep {
  padding: 0;
  box-sizing: border-box;
  font-weight: 600;
  line-height: 22px;
  color: #41bf7b;
  background-color: white;
  border: 2px solid #41bf7b;
  border-radius: 6px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #41bf7b;
    color: white;
  }
}

.offer-btn-loading ::v-deep {
  &:hover {
    color: #41bf7b;
    background-color: white;
  }
}

.mobile-title {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #878787;
  white-space: nowrap;
}

.offer-amount-block-mobile,
.offer-return-block-mobile,
.offer-issued-block-mobile,
.offer-rating-block-mobile {
  width: 100%;
  margin-bottom: 8px;
  display: none;
  justify-content: space-between;
  align-items: flex-end;
}

.offer-amount-block-mobile {
  margin-top: 15px;

  .offer-item-amount {
    width: inherit;
    display: block;
    text-align: end;
    font-size: 16px;
  }
}

.offer-return-block-mobile {
  .offer-item-return {
    width: inherit;
    display: block;
    text-align: end;
    font-size: 16px;
  }
}

.offer-issued-block-mobile {
  .offer-issued-by {
    width: inherit;
    display: block;
    text-align: end;
    font-size: 16px;
  }
}

.offer-rating-block-mobile {
  margin-bottom: 15px;
  .offer-rating {
    width: inherit;
    display: block;
    text-align: end;
    font-size: 16px;
  }
}

.offer-btn-block-mobile {
  height: 50px;
  width: 100%;
  display: none;
}

@media screen and (max-width: 1250px) {
  .title-item {
    display: none;
  }
  .offer-item {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    height: auto;
  }

  .offer-img,
  .offer-item-amount,
  .offer-item-return,
  .offer-issued-by,
  .offer-rating,
  .offer-btn-block {
    display: none;
  }

  .offer-amount-block-mobile,
  .offer-return-block-mobile,
  .offer-issued-block-mobile,
  .offer-rating-block-mobile {
    display: flex;
  }

  .offer-btn-block-mobile {
    display: block;
  }
}

@media screen and (max-width: 600px) {
  .offers-block {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  .offer-item {
    width: 100%;
  }
}
</style>
